/* eslint-disable class-methods-use-this */
const RenderTime = require('utils/framework/performance/RenderTime');
const Stack = require('utils/framework/performance/Stack');

let _stack;
let _renderTime;

class Performance {
    constructor() {
        _stack = new Stack();
        _renderTime = new RenderTime();
    }

    get stack() {
        return _stack;
    }

    get renderTime() {
        return _renderTime;
    }

    static initialize = () => {
        Sephora.performance = new Performance();
        require('utils/framework/Perf');
    };

    clear = () => {
        _stack.clear();
        _renderTime.clear();
    };
}

module.exports = Performance;
